import { __rest } from "tslib";
import * as React from 'react';
import { tupleNum } from '../_util/type';
import warning from '../_util/warning';
import Base from './Base';
const TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5);
const Title = React.forwardRef((props, ref) => {
    const { level = 1 } = props, restProps = __rest(props, ["level"]);
    let component;
    if (TITLE_ELE_LIST.includes(level)) {
        component = `h${level}`;
    }
    else {
        warning(false, 'Typography.Title', 'Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.');
        component = 'h1';
    }
    return React.createElement(Base, Object.assign({ ref: ref }, restProps, { component: component }));
});
export default Title;
